import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import { LanguageConsumer } from '../../state'

const Query = ({ render }) => (
  <LanguageConsumer>
    {({ lang }) => (
      <StaticQuery
        query={graphql`
          query {
            allFile(
              filter: { relativePath: { glob: "content/pages/contact/*.md" } }
            ) {
              nodes {
                relativePath
                childMarkdownRemark {
                  frontmatter {
                    content {
                      title
                      disclaimer
                      partnerships_link
                      events_link
                      office_address {
                        title
                        company_name
                        building
                        street
                        city
                      }
                      social_links {
                        twitter
                        facebook
                        github
                        linkedin
                        youtube
                      }
                      partnerships_form {
                        form_title
                        thank_you_response
                        message
                      }
                      contact_form {
                        form_title
                        external_event
                        external_event_form_link
                        partnerships
                        partnerships_link
                        name_label
                        email_label
                        subject_label
                        message_label
                        submit_label
                        thank_you_response
                        field_required
                        subjects {
                          general
                          media
                          sales
                          partnerships
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `}
        render={({ allFile }) => {
          const content = allFile.nodes
            .filter(
              (node) =>
                node.relativePath === `content/pages/contact/contact-${lang}.md`
            )
            .shift()
          if (!content || !content.childMarkdownRemark)
            throw new Error(
              `No contact translations found for language ${lang}`
            )
          return render(content.childMarkdownRemark.frontmatter.content)
        }}
      />
    )}
  </LanguageConsumer>
)

Query.propTypes = {
  render: PropTypes.func.isRequired
}

export default Query
